import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { filter, firstValueFrom } from 'rxjs';
import { ExperimentStage } from '../../models/experimentStageEnum';

@Component({
  selector: 'app-ongoing-experiment-list',
  imports: [CommonModule],
  templateUrl: './ongoing-experiment-list.component.html',
  styleUrl: './ongoing-experiment-list.component.scss',
})
export class OngoingExperimentListComponent implements OnInit, OnDestroy {
  private routerSubscription: any;

  allOngoingExperiments: any[] = [];

  constructor(
    private router: Router,
    private dbService: NgxIndexedDBService
  ) {}

  ngOnInit() {
    this.getOngoingExperiments();
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        // Reload list of ongoing experiment every time this route becomes active
        this.getOngoingExperiments();
      });
  }

  async getOngoingExperiments() {
    this.allOngoingExperiments = (
      await firstValueFrom(this.dbService.getAll('participants'))
    ).filter(
      (x: any) => x.experimentProgress.currentStage !== ExperimentStage.Complete
    );
  }

  async deleteExperiment(participantIdentifier: string) {
    if (confirm(`確定要刪除參加者 ${participantIdentifier} 的測試記錄嗎？`)) {
      try {
        // Delete from participants table
        await firstValueFrom(this.dbService.delete('participants', participantIdentifier));
        // Delete from responses table if exists
        await firstValueFrom(this.dbService.delete('responses', participantIdentifier));
        // Update the local array immediately
        this.allOngoingExperiments = this.allOngoingExperiments.filter(
          exp => exp.participantIdentifier !== participantIdentifier
        );
      } catch (error) {
        console.error('Error deleting experiment:', error);
        alert(`刪除參加者 ${participantIdentifier} 的測試記錄失敗`);
      }
    }
  }

  getLocalUpdateTime(updateTimeUTC: string) {
    return new Date(updateTimeUTC).toLocaleDateString();
  }

  continueExperiment(participantIdentifier: string) {
    this.enterFullScreen();
    
    // Find the participant to get the trial sequence number
    const participant = this.allOngoingExperiments.find(
      exp => exp.participantIdentifier === participantIdentifier
    );
    
    if (participant && participant.trialSequenceNumber) {
      this.router.navigate(['/experiment', participantIdentifier, participant.trialSequenceNumber], {
        state: { fromOngoing: true }
      });
    } else {
      alert('無法找到測試序列號碼，請重新開始測試');
    }
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  // Enter full screen
  private enterFullScreen() {
    const doc = document.documentElement;
    if (doc.requestFullscreen) {
      doc.requestFullscreen();
    }
  }
}
